import { Badge } from "@/components/ui/badge";

const DEFAULT_COLORS = {
  normal: { bg: "bg-[#32D74B]", text: "text-black" },
  suspicious: { bg: "bg-[#FF9F0A]", text: "text-black" },
  fraud: { bg: "bg-[#FF3B30]", text: "text-black" },
};

function resolveLevel(status, score, customLevels) {
  if (!customLevels || customLevels.length === 0) return null;
  // First try matching by key
  const byKey = customLevels.find((lv) => lv.key === status);
  if (byKey) return byKey;
  // Fallback: match by score range
  if (score != null) {
    const byScore = customLevels
      .slice()
      .sort((a, b) => b.min - a.min)
      .find((lv) => score >= lv.min && score <= lv.max);
    if (byScore) return byScore;
  }
  return null;
}

export function StatusBadge({ status, score, blink = true, labels, customLevels }) {
  const matched = resolveLevel(status, score, customLevels);

  let label;
  let bgStyle = null;
  let useFallbackClass = true;

  if (matched) {
    label = matched.label.toUpperCase();
    bgStyle = { backgroundColor: matched.color, color: "#000" };
    useFallbackClass = false;
  } else {
    const fallbackLabels = labels || {};
    label = (fallbackLabels[status] || status || "UNKNOWN").toUpperCase();
  }

  const c = DEFAULT_COLORS[status] || DEFAULT_COLORS.normal;
  const isNormal = matched ? matched.min === 0 : status === "normal";
  const shouldBlink = blink && !isNormal;

  return (
    <div className="flex items-center gap-2">
      <Badge
        className={`font-semibold rounded-sm text-[10px] uppercase tracking-wider border-0 ${
          shouldBlink ? "animate-blink-alert" : ""
        } ${useFallbackClass ? `${c.bg} ${c.text}` : ""}`}
        style={bgStyle || undefined}
      >
        {label}
      </Badge>
      <span className="font-mono-data text-xs text-[#A3A3A3]">{score}</span>
    </div>
  );
}

// Keep backward compat alias
export const RiskBadge = StatusBadge;
